"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
var _default = exports.default = {
  name: 'mall',
  components: {},
  data: function data() {
    return {};
  },
  mounted: function mounted(options) {},
  methods: {}
};